// extracted by mini-css-extract-plugin
module.exports = {"rgpdWrapper":"_tPDF","rgpdBanner":"_2BFad","main":"jVNpL","text":"_2MLP1","acceptCookieButton":"_2dG68"};